import { ref, computed, onMounted } from 'vue';

export default function useZillowProfile(contact) {
  const zillowProfile = ref(null);
  const zillowProfiles = ref([]);
  const possibleMatches = ref(false);
  const displayCount = ref(1);

  const visibleProfiles = computed(() =>
    zillowProfiles.value ? zillowProfiles.value.slice(0, displayCount.value) : []
  );

  async function fetchZillowData(url) {
    try {
      const response = await fetch(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer 539e262f657e36547ff6573362420368',
        },
      });
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error('Fetch error:', error);
      return null;
    }
  }

  async function getZillowProfile() {
    const emailUrl = `https://api.bridgedataoutput.com/api/v2/OData/reviews/Reviewees?$filter=RevieweeEmail eq '${contact.email}'`;
    let data = await fetchZillowData(emailUrl);

    if (data && data['@odata.count'] > 0) {
      zillowProfile.value = data.value[0];
    } else if (data && !data.error) {
      const nameUrl = `https://api.bridgedataoutput.com/api/v2/OData/reviews/Reviewees?$filter=RevieweeFullName eq '${contact.name}'`;
      data = await fetchZillowData(nameUrl);
      if (data && data['@odata.count'] > 0) {
        zillowProfiles.value = data.value;
        possibleMatches.value = true;
      }
    } else if (data && data.error) {
      console.error('API error:', data.error);
    }
  }

  function showMoreProfiles() {
    displayCount.value += 4;
  }

  onMounted(getZillowProfile);

  return {
    zillowProfile,
    zillowProfiles,
    possibleMatches,
    displayCount,
    visibleProfiles,
    showMoreProfiles,
  };
}
